export default new (class {
  constructor() {
    this.division = 0
    this.intervalId = null
    this.callbacks = []
    this.time = Date.now() // 服务器当前时间
    this.hasInited = false // 是否已初始化过服务器当前时间
  }

  // 设置服务器当前时间
  init(initTime = Date.now()) {
    if (!initTime) {
      initTime = Date.now()
    }
    this.division = Date.now() - initTime
    clearInterval(this.intervalId)
    this.time = Date.now() - this.division
    this.intervalId = setInterval(() => {
      this.time = Date.now() - this.division
      this.timeTick()
    }, 1000)
    this.hasInited = true
  }

  timeTick(time) {
    this.callbacks.forEach(func => func(this.time))
  }

  add(func) {
    // 加入队列后立即执行一次tick，防止出现1s后才执行tick的延迟误差
    func(Date.now() - this.division)

    if (this.callbacks.indexOf(func) < 0) {
      this.callbacks.push(func)
    }
  }

  remove(func) {
    const index = this.callbacks.indexOf(func)

    if (index >= 0) {
      this.callbacks.splice(index, 1)
    }
  }
})()

function formatRestTime(time) {
  return {
    d: parseInt(time / (3600000 * 24)) > 9 ? parseInt(time / (3600000 * 24)) : '0' + parseInt(time / (3600000 * 24)),
    h: parseInt(time / 3600000) % 24 > 9 ? parseInt(time / 3600000) % 24 : '0' + (parseInt(time / 3600000) % 24),
    m: parseInt(time / 60000) % 60 > 9 ? parseInt(time / 60000) % 60 : '0' + (parseInt(time / 60000) % 60),
    s: parseInt((time % 60000) / 1000) > 9 ? parseInt((time % 60000) / 1000) : '0' + parseInt((time % 60000) / 1000)
  }
}

export { formatRestTime }
